import { type SvgIconTypes } from '@uikit/svg-icon';
import { type InnerComponent, TagName as CommonTagName } from '@uikit/types';
import type { ComponentType } from 'svelte';

export type IconData = SvgIconTypes.IconData;

export enum TagName {
    A = CommonTagName.A,
    Button = CommonTagName.Button,
}

export interface Props<T extends Record<string, string>> {
    list: DataItem<ComponentType, ComponentType, T>[];
    active: keyof T;
    activeClasses: string;
    bold?: boolean;
    tagName?: TagName;
    classes?: string;
    rootClasses?: string;
    isActiveClikable?: boolean;
    hasDataValue?: boolean;
}

export interface DataItem<LeftComponent extends ComponentType, RightComponent extends ComponentType, T> {
    value: keyof T;
    text?: string;
    href?: string;
    icon?: IconData;
    componentLeft?: InnerComponent<LeftComponent>;
    componentRight?: InnerComponent<RightComponent>;
}
